<ng-template #footerActions>
  <ng-container *ngIf="isReadOrScrollRequired">
    <button class="def-button" [disabled]="buttonDisabled || disableButtonBeforeScroll"
            (click)="isLastDocument ? onClose() : goToNextDocument()">
      <ng-container *ngIf="buttonDisabled && counterBlockButton > 0">
        {{ "Wait" | translate }} {{ counterBlockButton }}s
      </ng-container>
      <ng-container *ngIf="!(buttonDisabled && counterBlockButton > 0)">
        {{ isLastDocument ? ("Close" | translate) : ("NextDocument" | translate) }}
      </ng-container>
    </button>
  </ng-container>

  <ng-container *ngIf="!isReadOrScrollRequired">
    <button class="def-button secondary" *ngIf="!isLastDocument" (click)="onClose()">
      {{ "Close" | translate }}
    </button>
    <button class="def-button" (click)="isLastDocument ? onClose() : goToNextDocument()">
      {{ isLastDocument ? ("Close" | translate) : ("NextDocument" | translate) }}
    </button>
  </ng-container>
</ng-template>

<div class="container" [class.full-mode]="fullViewer" (keydown)="onKeyDown($event)">
  <mat-icon class="close-icon" (click)="onDismiss()" *ngIf="!isLoadingConfig">close</mat-icon>
  <div class="header">
    <h6 class="title-large" *ngIf="isConfidential">
      <mat-icon>visibility</mat-icon>
      <span class="title-text">{{ "Confidential_Document" | translate }}</span>
    </h6>
    <span class="doc-counter" *ngIf="hasNavigation">
      {{ "DocumentCounter" | translate: { current: currentDocIndex + 1, total: totalDocs } }}
    </span>
  </div>

  <div>
    <p
      *ngIf="isConfidential"
      class="confidential-instruction"
    >
      {{ "ConfidentialPdfScrollInstruction" | translate }}
    </p>
  </div>


  <div
    class="content"
    [class.full-viewer]="fullViewer"
    [class.rotated]="fullViewer && rotated"
    #pdfWrapper
    (touchstart)="onViewerTouchStart($event)"
    (touchmove)="onViewerTouchMove($event)"
    (touchend)="onViewerTouchEnd($event)"
    (touchcancel)="onViewerTouchEnd($event)"
  >
    <pdf-viewer
      *ngIf="url"
      [src]="url"
      class="pdf-viewer"
      [style.transform]="pinchScale !== 1 ? 'scale(' + pinchScale + ')' : null"
      [render-text]="false"
      [fit-to-page]="false"
      [zoom]="zoom"
      [zoom-scale]="'page-width'"
      [rotation]="0"
      [show-all]="true"
      [autoresize]="true"
      [show-borders]="false"
      [stick-to-page]="true"
      [original-size]="true"
      (after-load-complete)="onLoadComplete($event)"
    ></pdf-viewer>
    <div class="confidential" *ngIf="isConfidential">
      <div class="watermark">
        <h1>{{"ConfidentialWaterMark" | translate}}</h1>
        <p>{{legalName}} {{documentId}}</p>
      </div>
    </div>

    <div class="zoom-buttons">
      <mat-icon (click)="incrementZoom(0.1)">zoom_in</mat-icon>
      <mat-icon (click)="incrementZoom(-0.1)">zoom_out</mat-icon>
    </div>

    <button
      type="button"
      class="fv-enter"
      *ngIf="isMobile && !fullViewer && url"
      [attr.aria-label]="'EnterFullViewer' | translate"
      [title]="'EnterFullViewer' | translate"
      (click)="enterFullViewer()"
    >
      <mat-icon>fullscreen</mat-icon>
    </button>

    <ng-container *ngIf="fullViewer">
      <span class="fv-hint" *ngIf="isConfidential && !canMarkCurrentDocumentAsViewed">
        {{ "ConfidentialPdfScrollInstruction" | translate }}
      </span>

      <div class="fv-bar">
        <button
          type="button"
          class="fv-btn"
          *ngIf="!isLandscapeViewport"
          [attr.aria-label]="'RotateDocument' | translate"
          [title]="'RotateDocument' | translate"
          (click)="toggleRotation()"
        >
          <mat-icon>screen_rotation</mat-icon>
        </button>
        <button
          type="button"
          class="fv-btn"
          [attr.aria-label]="'ExitFullViewer' | translate"
          [title]="'ExitFullViewer' | translate"
          (click)="exitFullViewer()"
        >
          <mat-icon>fullscreen_exit</mat-icon>
        </button>
      </div>

      <div class="fv-footer" *ngIf="(isConfidential || hasNavigation) && !isLoadingConfig">
        <ng-container *ngTemplateOutlet="footerActions"></ng-container>
      </div>
    </ng-container>
  </div>

  <div class="footer" *ngIf="(isConfidential || hasNavigation) && !isLoadingConfig && !fullViewer">
    <ng-container *ngTemplateOutlet="footerActions"></ng-container>
  </div>
</div>
